<template>
    <modal :show="show" v-on:update:show="handleModalClose">
        <template slot="header">
            <h5 class="modal-title">New Queue</h5>
        </template>

        <template>
            <form>
                <div class="row">
                    <div class="col">
                        <base-input label="Name"
                                    type="text"
                                    placeholder="Enter name"
                                    v-model="name"
                                    name="name"
                                    v-validate="'required'"
                                    required
                                    :error="getError('name')"
                                    @input="handleNameInputChange"
                        >
                            <small slot="helperText" id="nameHelp" class="form-text text-muted">This will be used
                                throughout
                                the
                                portal to identify this queue.
                            </small>
                        </base-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div>
                            <div>
                                <label>Timeout</label>
                            </div>
                            <el-input-number v-model="timeout" :min="1" size="small"
                                             :max="300"></el-input-number>
                            <small id="timeoutHelp" class="form-text text-muted">
                                Each ring is about 4 seconds. {{ timeout }} seconds is about {{
                                timeoutRings }} rings.
                            </small>
                        </div>
                        <hr>
                        <div>
                            <base-input label="Strategy">
                                <select
                                        v-model="strategy"
                                        class="form-control"
                                        size="small"
                                        name="strategy">
                                    <option class="select-primary"
                                            label="Ring all"
                                            value="ringall">
                                    </option>
                                    <option
                                            class="select-primary"
                                            label="Random"
                                            value="random">
                                    </option>
                                    <option
                                            class="select-primary"
                                            label="Round Robin"
                                            value="rrmemory">
                                    </option>
                                    <option
                                            class="select-primary"
                                            label="One By One"
                                            value="ring-progressively">
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <device-number-selector :devices="devices" :numbers="numbers"
                                                v-on:number-add="handleDestinationNumberAdd()"
                                                v-on:number-remove="handleDestinationNumberRemove($event)"
                                                v-on:number-update="handleDestinationNumberUpdate($event)"
                                                v-on:device-add="handleDeviceAdd($event)"
                                                v-on:device-remove="handleDeviceRemove($event)"
                        ></device-number-selector>
                    </div>
                </div>

            </form>
        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('update:show', false)">Close</base-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import DeviceNumberSelector from "../Ringgroup/DeviceNumberSelector";

    export default {
        name: "NewQueueModal",
        components: {
            DeviceNumberSelector,
            Modal,
        },
        props: {
            show: Boolean,
        },
        computed: {
            timeoutRings() {
                return Math.floor(this.timeout / 4);
            }
        },
        data() {
            return {
                name: null,
                saving: false,
                numbers: [],
                devices: [],
                strategy: 'ringall',
                timeout: 30,
            }
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.save()
                    }
                })
            },
            handleNameInputChange(value) {
                this.name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
            },
            handleModalClose(value) {
                this.$emit('update:show', value);
            },
            save() {
                this.saving = true;
                this.$store.dispatch('queue/create', {
                    name: this.name,
                    devices: this.devices,
                    numbers: this.numbers,
                    timeout: this.timeout,
                    strategy: this.strategy,
                }).then(() => {
                    this.$emit('update:show', false);
                    this.$emit('created');

                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Queue created!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });
                }).catch((error) => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Failed to create queue',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.saving = false;
                });
            },
            handleDestinationNumberAdd() {
                this.numbers.push('+99')
            },
            handleDestinationNumberUpdate(event) {
                let number = event.number;
                let nIndex = event.nIndex;
                this.numbers[nIndex] = number;

            },
            handleDestinationNumberRemove(event) {
                let number = event.number;
                this.numbers = this.numbers.filter(d => d !== number);
            },
            handleDeviceAdd(event) {
                let device = event.device;
                this.devices.push(device);
            },
            handleDeviceRemove(event) {
                let name = event.name;
                this.devices = this.devices.filter(d => d.name !== name);
            }
        }
    }
</script>

<style scoped>

</style>